module.exports = __webpack_public_path__ + "static/media/icon-dropdown.64363468.svg";